export enum CAPITAL_TYPE {
    DEPOSIT = 0,
    WITHDRAW = 1,
    DELEGATE = 2,
    UNDELEGATE = 3,
}